"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSearch = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const material_1 = require("@mui/material");
const InputBase_1 = tslib_1.__importDefault(require("@mui/material/InputBase"));
const providers_1 = require("@mne-core/providers");
const IconComponent_1 = tslib_1.__importDefault(require("../IconComponent"));
const StyledComponents_1 = require("./StyledComponents");
const Search = (0, material_1.styled)("div")(({ theme }) => ({
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    background: "rgba(255, 255, 255, 0.09)",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(-1),
    width: "auto",
}));
const SearchIconWrapper = (0, material_1.styled)("div")(({ theme }) => ({
    color: StyledComponents_1.DARK_TEXT_SECONDARY,
    paddingLeft: theme.spacing(1),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));
const InputBase = (0, material_1.styled)(InputBase_1.default)(() => ({
    color: StyledComponents_1.DARK_TEXT_SECONDARY,
    "& .MuiInputBase-input": {
        paddingLeft: "2.5em",
        width: "100%",
    },
}));
const handleSearch = (event) => {
    // Using `currentTarget` instead of `target`. Since TS lies and says `target.value` is not defined
    const inputValue = event.currentTarget.value;
    // We only care about if the user press enter.
    if (!(event.key === "Enter"))
        return;
    event.preventDefault();
    const AGGREGATED_EVENT_REGEX = /^(AGGR|NIDS)/;
    // If this is an aggregated event, redirect to event page.
    if (inputValue.match(AGGREGATED_EVENT_REGEX)) {
        window.location.href = (0, providers_1.toSpaUrl)({
            pathname: `/event/redirect/view/${inputValue}`,
            search: "",
        });
    }
    else {
        // Everything not an aggregated event, redirect to case.
        window.location.href = (0, providers_1.toSpaUrl)({
            pathname: `case/redirect/menuSearch/`,
            search: (0, providers_1.encodeUrlCriteria)({
                inputValue,
            }),
        });
    }
};
exports.handleSearch = handleSearch;
const ArgusMenuSearch = ({ open }) => (react_1.default.createElement(react_1.default.Fragment, null, open && (react_1.default.createElement(Search, null,
    react_1.default.createElement(SearchIconWrapper, null,
        react_1.default.createElement(IconComponent_1.default, { iconId: "search" })),
    react_1.default.createElement(InputBase, { onKeyDown: exports.handleSearch })))));
exports.default = ArgusMenuSearch;
